export default __webpack_public_path__ + "static/media/jszbg.5cc97210.png";